import { onBeforeUnmount, onMounted, type Ref } from 'vue';

export function useClickOutside(
  target: Ref<HTMLElement | null>,
  handler: (event: MouseEvent) => void
) {
  function onMouseDown(event: MouseEvent) {
    const el = target.value;
    if (!el) return;
    if (!el.contains(event.target as Node)) handler(event);
  }

  onMounted(() => document.addEventListener('mousedown', onMouseDown));
  onBeforeUnmount(() => document.removeEventListener('mousedown', onMouseDown));
}
